import { render, staticRenderFns } from "./roleBind.vue?vue&type=template&id=268ce484&"
import script from "./roleBind.vue?vue&type=script&lang=js&"
export * from "./roleBind.vue?vue&type=script&lang=js&"
import style0 from "./roleBind.vue?vue&type=style&index=0&id=268ce484&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports